import { render, staticRenderFns } from "./SectionImage.vue?vue&type=template&id=01993166"
import script from "./SectionImage.vue?vue&type=script&lang=js"
export * from "./SectionImage.vue?vue&type=script&lang=js"
import style0 from "./SectionImage.vue?vue&type=style&index=0&id=01993166&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports